import { action } from "../common/Action"
import { messageAlert } from "../common/components/confirm";
import { CaldaieClient, CaldaiaDto, CaldaiaDataDto } from "../generated";
import { orderBy } from "lodash";

const service = new CaldaieClient();

class CaldaieActions {
    @action
    async add(caldaia: CaldaiaDataDto) {
        const id = await service.add(caldaia);
        return { ...caldaia, idCaldaia: +id } as CaldaiaDto;
    }
    @action
    async update(id: number, caldaia: CaldaiaDataDto) {
        await service.update(caldaia, id);
        return { ...caldaia, idCaldaia: +id } as CaldaiaDto;
    }
    @action
    getCaldaia(id: number) {
        return service.get(id);
    };
    @action
    getAll() {
        return service.getAll()
    };
    @action
    async getCaldaieByMarca(marca: string) {
        return { marca, data: orderBy(await service.getCaldaieByMarca(marca, false), x => x.modelloCaldaia) };
    };
    @action
    async getListaNuoveCaldaiePrecaricate(marca: string) {
        const caldaie = await service.getListaNuoveCaldaiePrecaricate(marca);
        return { marca, caldaie }
    };
    @action
    inserisciCaldaiePrecaricate(caldaie: CaldaiaDto[]) {
        return service.inserisciCaldaiePrecaricate(caldaie);
    };
    @action
    getMarcheCaldaieGlobal() {
        return service.getAllMarcheCaldaieList();
    };

    @action
    async delete(idCaldaia: number) {
        const deleteOk = await service.deleteCaldaia(idCaldaia);
        if (!deleteOk) {
            messageAlert("Impossibile cancellare l'anagrafica caldaia in quanto è utilizzata su impianti registrati.", "Cancellazione modello caldaia")
        }
        return { deleteOk, idCaldaia }
    };
}
export default new CaldaieActions();